import React, { useState, useEffect, useContext } from 'react'
import {
  Radio,
  Form,
  Input,
  Button,
  Upload,
  Row,
  Col,
  Select,
  DatePicker,
  Space,
  Switch,
  Table,
  Popconfirm,
  Tooltip,
  Modal,
  InputNumber,
} from 'antd'
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons'
import '../../../modules/Clients/clients.css'
import moment from 'moment'
import { GET_INVOICE_SETTING } from '../graphql/Queries'
import { UPDATE_INVOICE_SETTING } from '../graphql/Mutations'
import { GET_PLANS } from '../../Plans/graphql/Query'
import { CREATE_PLAN, DELETE_PLAN, UPDATE_PLAN } from '../../Plans/graphql/Mutation'
import client from 'apollo'
import InvoiceTable from './invoiceTable'
import { AppContext } from 'AppContext'
import openNotification from 'utils/Notification'
import CustomMeta from 'components/CustomMeta'
import { isEmpty } from 'lodash'
import Loader from 'components/loaders/Loader'
import { canUserEdit, canUserAdd, canUserDelete, canUserSave } from 'utils/User'

const FormItem = Form.Item
const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 24 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
}

const Invoice = () => {
  const {
    dispatch,
    state: { isMobile, currentUser, userPermissions, isClient } = {},
  } = useContext(AppContext) || {}
  const canEdit = canUserEdit(userPermissions || currentUser, isClient)
  const canAdd = canUserAdd(userPermissions || currentUser, isClient)
  const canDelete = canUserDelete(userPermissions || currentUser, isClient)
  const canSave = canUserSave(userPermissions || currentUser, isClient)

  const [getData, setGetData] = useState({})
  const [invoiceDateValue, setInvoiceDate] = useState('MANUALLY')
  const [fileList, setFileList] = useState(undefined)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [invoice, setInvoice] = useState(moment().format())
  const [uploadDataLoader, setUploadDataLoader] = useState(false)
  const [highLow, setHighLow] = useState(false)

  useEffect(() => {
    setLoading(true)
    client
      .query({
        query: GET_INVOICE_SETTING,
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        dispatch({
          type: 'INVOICE_SETTING',
          data: res.data.getInvoiceSetting,
        })
        setInvoice(res.data.getInvoiceSetting.invoiceDate)
        setGetData(res.data.getInvoiceSetting)
        setInvoiceDate(res.data.getInvoiceSetting.invoiceDateType)
        setHighLow(
          res.data.getInvoiceSetting.selectAmcPercentage === 'high'
            ? true
            : false
        )
        setLoading(false)
      })
      .catch((err) => console.log(err))
  }, [dispatch])

  useEffect(() => {
    let array = []
    if (!isEmpty(getData)) {
      Promise.all(
        getData?.amcDates.map(async (item, index) => {
          array.push({
            ...item,
            invoiceDate: moment(invoice).format('DD-MMM-YYYY'),
            key: index + 1,
          })
        })
      )
      setData(array)
    }
  }, [invoice, getData])

  if (isEmpty(getData)) return <Loader />

  const dateInvoice = (e) => {
    if (e.target.value === 'AUTO') {
      setInvoice(moment().format('DD-MMM-YYYY'))
    } else {
      setInvoice(getData?.invoiceDate)
    }
    setInvoiceDate(e.target.value)
  }

  const onFinish = (values) => {
    if (!canEdit || !canSave) return
    setUploadDataLoader(true)
    // if (fileList === undefined) {
    //   delete values.qrImage
    // }

    values = {
      ...values,
      qrImage: values.qrImage[0].originFileObj,
      amcDates: data,
      amcPercentage: getData?.amcPercentage || [],
      autoGenerateInvoiceStartNumber: +values.autoGenerateInvoiceStartNumber,
      invoiceDate:
        invoiceDateValue === 'AUTO'
          ? moment().format('YYYY-MM-DD')
          : moment(invoice).format('YYYY-MM-DD'),
      invoiceDateType: invoiceDateValue,
      selectAmcPercentage: highLow ? 'high' : 'low',
    }

    client
      .mutate({
        mutation: UPDATE_INVOICE_SETTING,
        variables: { data: values },
      })
      .then((res) => {
        dispatch({
          type: 'INVOICE_SETTING',
          data: res.data.updateInvoiceSetting,
        })
        // setGetData(res.data.updateInvoiceSetting)
        setData(JSON.parse(res?.data?.updateInvoiceSetting?.amcDates))
        setUploadDataLoader(false)
        openNotification('success', 'Update Invoice Setting Successfully')
      })
      .catch((err) => {
        console.log(err)
        setUploadDataLoader(false)
      })
      .finally(() => setUploadDataLoader(false))
  }

  const STRATEGY_NAMES = {
    '1005': 'ILTS',
    '1007': 'Marathon',
    '1017': 'FinRakshak',
    '1011': 'Dynamic Plan',
    '1018': 'Conservative',
  }

  const getStrategyName = (code, plansList = []) => {
    if (code === '1005') {
      return 'ILTS'
    }
    const matchingPlan = plansList.find((p) => p.strategyCode === code)
    if (matchingPlan) {
      return matchingPlan.name
    }
    if (STRATEGY_NAMES[code]) {
      return STRATEGY_NAMES[code]
    }
    return `Strategy ${code}`
  }

  const PlanWiseAmcConfigurator = () => {
    const [plans, setPlans] = useState([])
    const [loadingPlans, setLoadingPlans] = useState(false)
    const [selectedStrategy, setSelectedStrategy] = useState(null)
    const [ranges, setRanges] = useState([])
    const [showAddModal, setShowAddModal] = useState(false)
    const [newPlan, setNewPlan] = useState({ name: '', strategyCode: '', description: '' })
    const [saving, setSaving] = useState(false)

    const fetchPlansList = () => {
      setLoadingPlans(true)
      client
        .query({
          query: GET_PLANS,
          fetchPolicy: 'network-only',
        })
        .then((res) => {
          const fetchedPlans = res?.data?.getPlans || []
          setPlans(fetchedPlans)
          
          // Auto-select first strategy if none is selected
          const uniqueStrategies = [...new Set(fetchedPlans.map((p) => p.strategyCode).filter(Boolean))]
          if (uniqueStrategies.length > 0 && !selectedStrategy) {
            setSelectedStrategy(uniqueStrategies[0])
          }
          setLoadingPlans(false)
        })
        .catch((err) => {
          console.error(err)
          setLoadingPlans(false)
        })
    }

    useEffect(() => {
      fetchPlansList()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Sync ranges when strategy selection changes
    useEffect(() => {
      if (selectedStrategy && plans.length > 0) {
        const plansForStrategy = plans.filter(
          (p) => p.strategyCode === selectedStrategy || String(p.id) === String(selectedStrategy) || p.name === selectedStrategy
        )
        // Find the first plan that has non-empty AMC percentage ranges
        const planWithAmc = plansForStrategy.find((p) => {
          if (!p.amcPercentage) return false
          try {
            let parsed = typeof p.amcPercentage === 'string' ? JSON.parse(p.amcPercentage) : p.amcPercentage
            if (typeof parsed === 'string') parsed = JSON.parse(parsed)
            return Array.isArray(parsed) && parsed.length > 0
          } catch (e) {
            return false
          }
        }) || plansForStrategy.find((p) => p.amcPercentage)

        if (planWithAmc && planWithAmc.amcPercentage) {
          try {
            let parsed = typeof planWithAmc.amcPercentage === 'string'
              ? JSON.parse(planWithAmc.amcPercentage)
              : planWithAmc.amcPercentage
            if (typeof parsed === 'string') {
              parsed = JSON.parse(parsed)
            }
            if (Array.isArray(parsed)) {
              const normalized = parsed.map((item) => {
                const pVal = item?.percentage ?? item?.amcPercentage ?? item?.per
                const numP = pVal !== undefined && pVal !== null && pVal !== '' && !isNaN(Number(pVal)) ? Number(pVal) : undefined
                return {
                  ...item,
                  percentage: numP,
                  amcPercentage: numP,
                }
              })
              setRanges(normalized)
            } else {
              setRanges([])
            }
          } catch (e) {
            setRanges([])
          }
        } else {
          setRanges([])
        }
      } else {
        setRanges([])
      }
    }, [selectedStrategy, plans])

    const handleAddRangeRow = () => {
      setRanges([...ranges, { minExposure: 0, maxExposure: null, percentage: undefined, amcPercentage: undefined }])
    }

    const handleRemoveRangeRow = (index) => {
      const updated = [...ranges]
      updated.splice(index, 1)
      setRanges(updated)
    }

    const handleRangeFieldChange = (index, field, value) => {
      const updated = [...ranges]
      const currentItem = updated[index] || {}
      updated[index] = {
        ...currentItem,
        [field]: value,
      }
      if (field === 'percentage') {
        updated[index].amcPercentage = value
      }
      setRanges(updated)
    }

    const handleSaveRanges = () => {
      if (!canEdit || !canSave) return
      if (!selectedStrategy) return
      setSaving(true)
      const plansToUpdate = plans.filter(
        (p) => p.strategyCode === selectedStrategy || String(p.id) === String(selectedStrategy) || p.name === selectedStrategy
      )

      if (plansToUpdate.length === 0) {
        openNotification('error', 'No matching plan found to save AMC ranges.')
        setSaving(false)
        return
      }

      const cleanedRanges = ranges.map((r) => {
        const rawP = r.percentage ?? r.amcPercentage ?? r.per
        const pVal = rawP !== null && rawP !== undefined && rawP !== '' && !isNaN(Number(rawP)) ? Number(rawP) : 0
        return {
          minExposure: r.minExposure !== null && r.minExposure !== undefined && r.minExposure !== '' ? Number(r.minExposure) : 0,
          maxExposure: r.maxExposure !== null && r.maxExposure !== undefined && r.maxExposure !== '' ? Number(r.maxExposure) : null,
          percentage: pVal,
          amcPercentage: pVal,
        }
      })
      
      Promise.all(
        plansToUpdate.map((plan) =>
          client.mutate({
            mutation: UPDATE_PLAN,
            variables: {
              id: plan.id,
              data: {
                amcPercentage: cleanedRanges,
              },
            },
          })
        )
      )
        .then(() => {
          openNotification('success', `AMC Ranges for ${getStrategyName(selectedStrategy, plans)} saved successfully!`)
          fetchPlansList()
        })
        .catch((err) => {
          console.error(err)
          openNotification('error', 'Failed to save AMC ranges.')
        })
        .finally(() => {
          setSaving(false)
        })
    }

    const handleCreatePlan = () => {
      if (!canAdd || !canSave) return
      if (!newPlan.name || !newPlan.strategyCode) {
        openNotification('error', 'Please fill in Plan Name and Strategy Code')
        return
      }
      client
        .mutate({
          mutation: CREATE_PLAN,
          variables: {
            data: {
              name: newPlan.name,
              strategyCode: newPlan.strategyCode,
              description: newPlan.description || newPlan.name,
            },
          },
        })
        .then(() => {
          openNotification('success', 'Plan created successfully!')
          setShowAddModal(false)
          setNewPlan({ name: '', strategyCode: '', description: '' })
          fetchPlansList()
        })
        .catch((err) => {
          console.error(err)
          openNotification('error', 'Failed to create plan.')
        })
    }

    const handleDeleteStrategyPlans = (strategyCode) => {
      if (!canDelete) return
      const plansToDelete = plans.filter((p) => p.strategyCode === strategyCode)
      Promise.all(
        plansToDelete.map((plan) =>
          client.mutate({
            mutation: DELETE_PLAN,
            variables: {
              id: plan.id,
            },
          })
        )
      )
        .then(() => {
          openNotification('success', `All plans under strategy ${getStrategyName(strategyCode, plans)} deleted successfully.`)
          if (selectedStrategy === strategyCode) {
            setSelectedStrategy(null)
          }
          fetchPlansList()
        })
        .catch((err) => {
          console.error(err)
          openNotification('error', 'Failed to delete strategy plans.')
        })
    }

    // Group unique strategies for display
    const uniqueStrategies = []
    const strategyCodeSet = new Set()

    // First, handle ILTS group
    const hasILTS = plans.some((p) => p.strategyCode === '1005')
    if (hasILTS) {
      uniqueStrategies.push({
        strategyCode: '1005',
        name: 'ILTS',
      })
    }

    // Now, handle other plans individually
    plans.forEach((plan) => {
      if (plan.strategyCode !== '1005' && plan.strategyCode && !strategyCodeSet.has(plan.strategyCode)) {
        strategyCodeSet.add(plan.strategyCode)
        uniqueStrategies.push({
          strategyCode: plan.strategyCode,
          name: plan.name,
        })
      }
    })

    return (
      <div style={{ marginTop: '20px', border: '1px solid #d9d9d9', borderRadius: '8px', padding: '20px', background: '#fff', width: '100%', marginBottom: '20px' }}>
        <h3 style={{ marginBottom: '20px', fontWeight: 'bold' }}>AMC Percentages [Plan Wise]</h3>
        <Row gutter={[24, 24]}>
          {/* Left Side: Range Editor */}
          <Col xs={24} lg={16}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px', gap: '10px' }}>
              <Space style={{ flexWrap: 'wrap' }}>
                <span style={{ fontWeight: '500' }}>Plan:</span>
                <Select
                  style={{ width: '200px' }}
                  value={selectedStrategy}
                  onChange={(val) => setSelectedStrategy(val)}
                  placeholder="Select Plan"
                  loading={loadingPlans}
                >
                  {uniqueStrategies.map((strat) => (
                    <Select.Option key={strat.strategyCode} value={strat.strategyCode}>
                      {strat.name}
                    </Select.Option>
                  ))}
                </Select>
                {canAdd && (
                  <Button type="primary" onClick={() => setShowAddModal(true)}>
                    + Add Plan
                  </Button>
                )}
                {canDelete && selectedStrategy && (
                  <Popconfirm
                    title={
                      <div>
                        <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                          Do you really want to delete this plan?
                        </div>
                        <div style={{ fontSize: '12px', color: '#ff4d4f', marginBottom: '8px' }}>
                          Warning: If you delete this plan, you will lose your plan and settings from everywhere.
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                          Note: If you only want to delete or change values, please choose edit.
                        </div>
                      </div>
                    }
                    onConfirm={() => handleDeleteStrategyPlans(selectedStrategy)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="primary" danger>
                      Delete Plan
                    </Button>
                  </Popconfirm>
                )}
                {selectedStrategy && (
                  <span style={{ marginLeft: '15px', color: '#1890ff', fontWeight: 'bold', fontSize: '16px' }}>
                    {getStrategyName(selectedStrategy, plans)}
                  </span>
                )}
              </Space>

              {selectedStrategy && getStrategyName(selectedStrategy, plans) === 'ILTS' && (
                <div style={{
                  border: '1px solid #1890ff',
                  borderRadius: '4px',
                  padding: '6px 12px',
                  background: '#e6f7ff',
                  color: '#1890ff',
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}>
                  {plans.filter((p) => p.strategyCode === selectedStrategy).map((p) => p.name).join(', ')}
                </div>
              )}
            </div>

            {selectedStrategy ? (
              <div>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                  <thead>
                    <tr style={{ background: '#f5f5f5', borderBottom: '1px solid #d9d9d9' }}>
                      <th style={{ padding: '10px', textAlign: 'left' }}>From Amount (₹)</th>
                      <th style={{ padding: '10px', textAlign: 'left' }}>To Amount (₹)</th>
                      <th style={{ padding: '10px', textAlign: 'left' }}>AMC Percentage (%)</th>
                      <th style={{ padding: '10px', textAlign: 'center', width: '80px' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ranges.map((row, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                        <td style={{ padding: '8px' }}>
                          <InputNumber
                            style={{ width: '95%', margin: 0 }}
                            value={row.minExposure}
                            onChange={(val) => handleRangeFieldChange(idx, 'minExposure', val)}
                            min={0}
                            placeholder="Min Exposure"
                          />
                        </td>
                        <td style={{ padding: '8px' }}>
                          <InputNumber
                            style={{ width: '95%', margin: 0 }}
                            value={row.maxExposure}
                            onChange={(val) => handleRangeFieldChange(idx, 'maxExposure', val)}
                            min={0}
                            placeholder="Max Exposure"
                          />
                        </td>
                        <td style={{ padding: '8px' }}>
                          <InputNumber
                            style={{ width: '95%', margin: 0 }}
                            value={row.percentage ?? row.amcPercentage ?? row.per}
                            onChange={(val) => handleRangeFieldChange(idx, 'percentage', val)}
                            step={0.01}
                            min={0}
                            max={100}
                            placeholder="Percentage"
                          />
                        </td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>
                          <Button
                            size="small"
                            type="text"
                            danger
                            disabled={!canDelete}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '32px',
                              height: '32px',
                              minWidth: '32px',
                              padding: 0,
                              margin: 0,
                            }}
                            icon={<DeleteOutlined />}
                            onClick={() => handleRemoveRangeRow(idx)}
                          />
                        </td>
                      </tr>
                    ))}
                    {ranges.length === 0 && (
                      <tr>
                        <td colSpan={4} style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                          No ranges defined yet. Click "+ Add Row" to define range brackets.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <Space>
                  {canAdd && (
                    <Button type="dashed" onClick={handleAddRangeRow} icon={<PlusOutlined />}>
                      Add Row
                    </Button>
                  )}
                  <Button type="primary" onClick={handleSaveRanges} loading={saving} disabled={!canEdit || !canSave}>
                    Save Plan AMC Ranges
                  </Button>
                </Space>
              </div>
            ) : (
              <div style={{ padding: '40px 0', textAlign: 'center', color: '#999' }}>
                Please select or add a plan to configure its AMC percentages.
              </div>
            )}
          </Col>

          {/* Right Side: All Plans List */}
          <Col xs={24} lg={8}>
            <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '15px' }}>
              <h4 style={{ marginBottom: '15px', fontWeight: '600' }}>All Plans</h4>
              <Table
                dataSource={uniqueStrategies}
                rowKey="strategyCode"
                size="small"
                pagination={false}
                columns={[
                  {
                    title: 'Plan Name',
                    dataIndex: 'name',
                    key: 'name',
                    onCell: () => ({
                      style: { padding: '8px 12px' },
                    }),
                  },
                  {
                    title: 'Action',
                    key: 'action',
                    align: 'center',
                    width: '120px',
                    onCell: () => ({
                      style: { padding: '8px 12px' },
                    }),
                    render: (_, record) => (
                      <Space size="small">
                        {canEdit && (
                          <Tooltip title="Edit ranges">
                            <Button
                              size="small"
                              type="text"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '32px',
                                height: '32px',
                                minWidth: '32px',
                                padding: 0,
                                margin: 0,
                              }}
                              icon={<EditOutlined style={{ color: '#1890ff' }} />}
                              onClick={() => setSelectedStrategy(record.strategyCode)}
                            />
                          </Tooltip>
                        )}
                        {canDelete && (
                          <Tooltip title="Delete Plan">
                            <Popconfirm
                              title={
                                <div>
                                  <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                                    Do you really want to delete this plan?
                                  </div>
                                  <div style={{ fontSize: '12px', color: '#ff4d4f', marginBottom: '8px' }}>
                                    Warning: If you delete this plan, you will lose your plan and settings from everywhere.
                                  </div>
                                  <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                                    Note: If you only want to delete or change values, please choose edit.
                                  </div>
                                </div>
                              }
                              onConfirm={() => handleDeleteStrategyPlans(record.strategyCode)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Button
                                size="small"
                                type="text"
                                danger
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '32px',
                                  height: '32px',
                                  minWidth: '32px',
                                  padding: 0,
                                  margin: 0,
                                }}
                                icon={<DeleteOutlined />}
                              />
                            </Popconfirm>
                          </Tooltip>
                        )}
                      </Space>
                    ),
                  },
                ]}
              />
            </div>
          </Col>
        </Row>

        {/* Add Plan Modal */}
        <Modal
          title="Add New Plan"
          visible={showAddModal}
          onCancel={() => setShowAddModal(false)}
          footer={null}
        >
          <Form layout="vertical">
            <Form.Item label="Plan Name" required>
              <Input
                value={newPlan.name}
                onChange={(e) => setNewPlan({ ...newPlan, name: e.target.value })}
                placeholder="e.g. ILTS Plan"
              />
            </Form.Item>
            <Form.Item label="Strategy Code" required>
              <Input
                value={newPlan.strategyCode}
                onChange={(e) => setNewPlan({ ...newPlan, strategyCode: e.target.value })}
                placeholder="e.g. 1005"
              />
            </Form.Item>
            <Form.Item label="Description">
              <Input.TextArea
                value={newPlan.description}
                onChange={(e) => setNewPlan({ ...newPlan, description: e.target.value })}
                placeholder="Enter brief description"
                rows={3}
              />
            </Form.Item>
            <Form.Item style={{ textAlign: 'right', marginBottom: 0, marginTop: 24 }}>
              <Button onClick={() => setShowAddModal(false)} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" onClick={handleCreatePlan} disabled={!canAdd || !canSave}>
                Create
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }

  const handleDateChanges = (value) => {
    setInvoice(value)
  }

  const normFile = (e) => {
    setFileList([])
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  const canModifyQr = canEdit && canSave
  const canDeleteQr = canDelete && canEdit && canSave

  const customProps = {
    multiple: false,
    disabled: !canModifyQr,
    showUploadList: {
      showRemoveIcon: canDeleteQr,
      showPreviewIcon: true,
    },
    onRemove: (file) => {
      if (!canDeleteQr) {
        openNotification('error', 'You do not have permission to delete this file.')
        return false
      }
      setFileList([])
    },
    beforeUpload: (file) => {
      if (!canModifyQr) {
        openNotification('error', 'You do not have permission to upload files.')
        return false
      }
      setFileList(file)
      return false
    },
    fileList,
  }

  const options = [
    {
      value: '2018-19',
      label: '2018-19',
    },
    {
      value: '2019-20',
      label: '2019-20',
    },
    {
      value: '2020-21',
      label: '2020-21',
    },
    {
      value: '2021-22',
      label: '2021-22',
    },
    {
      value: '2022-23',
      label: '2022-23',
    },
    {
      value: '2023-24',
      label: '2023-24',
    },
    {
      value: '2024-25',
      label: '2024-25',
    },
    {
      value: '2025-26',
      label: '2025-26',
    },
    {
      value: '2026-27',
      label: '2026-27',
    },
    {
      value: '2027-28',
      label: '2027-28',
    },
    {
      value: '2028-29',
      label: '2028-29',
    },
    {
      value: '2029-30',
      label: '2029-30',
    },
    {
      value: '2030-31',
      label: '2030-31',
    },
    {
      value: '2031-32',
      label: '2031-32',
    },
    {
      value: '2032-33',
      label: '2032-33',
    },
    {
      value: '2033-34',
      label: '2033-34',
    },
    {
      value: '2034-35',
      label: '2034-35',
    },
    {
      value: '2035-36',
      label: '2035-36',
    },
    {
      value: '2036-37',
      label: '2036-37',
    },
    {
      value: '2037-38',
      label: '2037-38',
    },
    {
      value: '2038-39',
      label: '2038-39',
    },
    {
      value: '2039-40',
      label: '2039-40',
    },
  ]

  return loading ? (
    <Loader />
  ) : (
    <div className='main_dashboard_div'>
      <CustomMeta title={'Invoice'} description='' />

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            fontSize: isMobile ? '18px' : '24px',
            fontWeight: '600',
            lineHeight: '26px',
            letterSpacing: '-0.02em',
            textAlign: 'left',
            color: '#181C32',
          }}
        >
          Invoice Setting
        </div>
      </div>
      <Form
        style={{
          height: 'auto',
        }}
        {...formItemLayout}
        name='register'
        onFinish={onFinish}
        loading={loading}
        autoComplete='off'
        scrollToFirstError
        className='client-form Invoice-form'
        initialValues={{
          accountDetails: getData?.accountDetails,
          address: getData?.address,
          autoGenerateInvoiceStartNumber:
            getData?.autoGenerateInvoiceStartNumber,
          bankName: getData?.bankName,
          billTypeParticular: getData?.billTypeParticular,
          branchName: getData?.branchName,
          companyName: getData?.companyName,
          gstinNumber: getData?.gstinNumber,
          ifscCode: getData?.ifscCode,
          invoiceDateType: getData?.invoiceDateType,
          invoiceDate: moment(getData?.invoiceDate),
          invoiceNumber: getData?.invoiceNumber,
          invoiceYear: getData?.invoiceYear,
          panNumber: getData?.panNumber,
          upiId: getData?.upiId,
          type: getData?.type,
          webEmail: getData?.webEmail,
          otherMailId: getData?.otherMailId,
          qrImage: [
            {
              uid: `qrImage ${getData?.id}`,
              name: 'qrImage.png',
              url: getData?.qrImage,
            },
          ],
          amcPercentage: getData?.amcPercentage || [],
        }}
      >
        <FormItem
          name='type'
          label='Default Select'
          rules={[
            {
              required: true,
              message: 'Answer is require',
            },
          ]}
        >
          <Input disabled />
        </FormItem>
        <Row gutter={16}>
          <Col
            className='gutter-row invoice_setting_form  '
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Company Name'
              name='companyName'
              rules={[
                {
                  required: true,
                  message: 'Please input your Company Name!',
                },
              ]}
            >
              <Input placeholder='Enter Company' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Website & Email id'
              name='webEmail'
              rules={[
                {
                  required: true,
                  message: 'Please input your Website & Email id!',
                },
              ]}
            >
              <Input placeholder='Enter Website & Email id' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Address'
              name='address'
              rules={[
                {
                  required: true,
                  message: 'Please input your Address!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Address' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Invoice No'
              name='invoiceNumber'
              rules={[
                {
                  required: true,
                  message: 'Please input your Invoice No!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Invoice No' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Account Details'
              name='accountDetails'
              rules={[
                {
                  required: true,
                  message: 'Please input your Account Details!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Account Details' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Bank Name'
              name='bankName'
              rules={[
                {
                  required: true,
                  message: 'Please input your Bank Name!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Bank Name' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Branch Name'
              name='branchName'
              rules={[
                {
                  required: true,
                  message: 'Please input your Branch Name!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Branch Name' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='IFSC Code'
              name='ifscCode'
              rules={[
                {
                  required: true,
                  message: 'Please input your IFSC Code!',
                  pattern: new RegExp('^[A-Z]{4}0[A-Z0-9]{6}$'),
                },
              ]}
            >
              <Input placeholder='Please Enter your IFSC Code' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='PAN Number'
              name='panNumber'
              rules={[
                {
                  required: true,
                  message: 'Please input Valid PAN Number!',
                  pattern: new RegExp(
                    /[A-Za-z]{3}[ABCFGHLJPTFabcfghjpltf]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}/g
                  ),
                },
              ]}
            >
              <Input
                placeholder='Please Enter your PAN Number'
                style={{ textTransform: 'uppercase' }}
                maxLength='10'
              />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              type='number'
              label='Invoice Start Number'
              name='autoGenerateInvoiceStartNumber'
              rules={[
                {
                  required: true,
                  message: 'Please input Invoice Start Number!',
                },
              ]}
            >
              <Input placeholder='Please Enter your Invoice Start Number' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Invoice Date'
              name='invoiceDateType'
              rules={[
                {
                  // required: true,
                  message: 'Please input Invoice Date!',
                },
              ]}
            >
              <Radio.Group onChange={dateInvoice} value={invoiceDateValue}>
                <Radio value={'AUTO'}>Auto</Radio>
                <Radio value={'MANUALLY'}>Manual</Radio>
              </Radio.Group>

              {invoiceDateValue !== 'AUTO' && (
                <FormItem
                  name='invoiceDate'
                  rules={[
                    {
                      required: true,
                      message: 'Invoice Date is required!',
                    },
                  ]}
                >
                  <DatePicker
                    style={{ marginLeft: '20px' }}
                    getPopupContainer={(trigger) => trigger.parentElement}
                    value={
                      invoiceDateValue === 'AUTO'
                        ? moment().format('YYYY-MM-DD')
                        : ''
                    }
                    onChange={handleDateChanges}
                    format='DD-MMM-YYYY'
                  />
                </FormItem>
              )}
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='GST Number'
              name='gstinNumber'
              rules={[
                {
                  required: true,
                  message: 'Please input GST Number!',
                },
              ]}
            >
              <Input placeholder='Please Enter GST Number' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='UPI Id'
              name='upiId'
              rules={[
                {
                  required: true,
                  message: 'Please input UPI Id!',
                },
              ]}
            >
              <Input placeholder='Please Enter UPI Id' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='qrImage'
              label='QR image'
              valuePropName='fileList'
              getValueFromEvent={normFile}
            >
              <Upload
                name='qr-file'
                listType='picture'
                disabled={!canModifyQr}
                showUploadList={{
                  showRemoveIcon: canDeleteQr,
                  showPreviewIcon: true,
                }}
                {...customProps}
                accept='.jpeg,.png,.jpg,.pdf,.docx,.doc'
              >
                <Button disabled={!canModifyQr}>
                  <UploadOutlined /> Click to upload
                </Button>
              </Upload>
            </Form.Item>
          </Col>

          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Invoice FY'
              name='invoiceYear'
              rules={[
                {
                  required: true,
                  message: 'Please Select Invoice FY!',
                },
              ]}
            >
              <Select
                showSearch
                getPopupContainer={(trigger) => trigger.parentElement}
                placeholder='Select a Finance Year'
                optionFilterProp='children'
                options={options}
              />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Bill Type Particular'
              name='billTypeParticular'
              rules={[
                {
                  required: true,
                  message: 'Please input Bill Type Particular!',
                },
              ]}
            >
              <Input placeholder='Please Enter Bill Type Particular' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item
              label='Other Mail Id'
              name='otherMailId'
              rules={[
                {
                  required: true,
                  message: 'Please input Other Mail Id!',
                },
              ]}
            >
              <Input placeholder='Please Enter Other Mail Id' />
            </Form.Item>
          </Col>
          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={12}
          >
            <Form.Item label='Amc Percentage High or Low' name='highLow'>
              <Switch checked={highLow} onChange={(e) => setHighLow(e)} />
              <span style={{ marginLeft: '10px' }}>
                Select {highLow ? 'High' : 'Low'} Amc Percentage
              </span>
            </Form.Item>
          </Col>
          <Col xs={24}>
            <PlanWiseAmcConfigurator />
          </Col>

          <Col
            className='gutter-row invoice_setting_form'
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ width: '100%' }}
          >
            <Form.Item
              label='Amc Dates'
              rules={[
                {
                  required: true,
                  message: 'Please input Bill Type Particular!',
                },
              ]}
            >
              <InvoiceTable setData={setData} data={data} />
            </Form.Item>
          </Col>
        </Row>
        {/* // )} */}
        <Form.Item
          wrapperCol={{
            offset: 8,
            span: 16,
          }}
        >
          <Button
            type='primary'
            htmlType='submit'
            loading={uploadDataLoader}
            disabled={!canEdit || !canSave}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default Invoice
